import { useContext } from 'react';
import { PageContext } from './PageLoader';

export default function usePageContext() {
  const pageContext = useContext(PageContext);

  if (!pageContext) {
    throw new Error('PageContext was not initialized!');
  }

  return pageContext;
}
